var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
/// <reference lib="dom" />
import { normalizeUrl } from '@sisense/sdk-common';
import { addQueryParamsToUrl } from './helpers.js';
import { errorInterceptor, getResponseInterceptor } from './interceptors.js';
import { isSsoAuthenticator } from './sso-authenticator.js';
export class HttpClient {
    constructor(url, auth, env) {
        this.url = normalizeUrl(url);
        this.auth = auth;
        this.env = env;
    }
    login() {
        return this.auth.authenticate();
    }
    call(url, config, requestConfig) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.auth.isAuthenticating()) {
                yield this.auth.authenticated();
            }
            config.headers = config.headers || {};
            if (isSsoAuthenticator(this.auth)) {
                // allows cookies to be sent
                config.credentials = 'include';
            }
            this.auth.applyHeaders(config.headers);
            const fetchUrl = (requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.skipTrackingParam)
                ? url
                : addQueryParamsToUrl(url, {
                    trc: this.env,
                });
            const response = yield fetch(fetchUrl, config)
                .then(getResponseInterceptor(this.auth))
                .catch(errorInterceptor);
            if (response.status === 204 || // No content
                response.status === 304 // Not modified
            ) {
                return;
            }
            return ((requestConfig === null || requestConfig === void 0 ? void 0 : requestConfig.returnBlob)
                ? response.blob()
                : response.json().catch((e) => {
                    var _a, _b;
                    // some of APIs in Sisense returns 200 with empty body - so it's not possible
                    // to understand definitely is it empty or not until you will try to parse it
                    if (!((_b = (_a = e === null || e === void 0 ? void 0 : e.message) === null || _a === void 0 ? void 0 : _a.includes) === null || _b === void 0 ? void 0 : _b.call(_a, 'Unexpected end of JSON input'))) {
                        throw e;
                    }
                }));
        });
    }
    // eslint-disable-next-line max-params
    post(endpoint, data, options = {}, abortSignal, config) {
        const request = Object.assign({ method: 'POST', body: ((config === null || config === void 0 ? void 0 : config.nonJSONBody) ? data : JSON.stringify(data)), headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json;charset=UTF-8',
            }, signal: abortSignal }, options);
        return this.call(this.url + endpoint, request, config);
    }
    patch(endpoint, data, options = {}, abortSignal, config) {
        const request = Object.assign({ method: 'PATCH', body: ((config === null || config === void 0 ? void 0 : config.nonJSONBody) ? data : JSON.stringify(data)), headers: {
                Accept: 'application/json, text/plain, */*',
                'Content-Type': 'application/json;charset=UTF-8',
            }, signal: abortSignal }, options);
        return this.call(this.url + endpoint, request, config);
    }
    get(endpoint, request = {}, config) {
        return this.call(this.url + endpoint, Object.assign(Object.assign({}, request), { method: 'GET' }), config);
    }
    delete(endpoint, request = {}, config) {
        return this.call(this.url + endpoint, Object.assign(Object.assign({}, request), { method: 'DELETE' }), config);
    }
}
//# sourceMappingURL=http-client.js.map